/*
 * Add each page's JSON-LD schema here.
 *
 * Example:
 * "/": [
 *   {
 *     "@context": "https://schema.org",
 *     "@type": "Organization",
 *     "name": "Workdayz"
 *   }
 * ]
 *
 * Keep multiple schemas for the same page inside the same array.
 * Dynamic route patterns such as "/blog/:slug" are also supported.
 */
const pageSchemas = {
  "/": [],
  "/courses": [],
  "/blog": [],
  "/about-us": [],
  "/product": [],
  "/uniform-manufacturer/retail-brand-spaces": [
    {
      "@context": "https://schema.org",
      "@type": "LocalBusiness",
      "@id": "https://workdayz.in/#localbusiness",
      "name": "Workdayz by Saraogi",
      "alternateName": "The Saraogi Clothing Company",
      "description": "Workdayz by Saraogi is a leading uniform manufacturer in India specialising in custom retail brand space uniforms, corporate uniforms, aviation uniforms, hospitality uniforms, healthcare uniforms, and school uniforms. We combine premium fabrics with precision tailoring and advanced production technology to deliver superior uniform solutions.",
      "url": "https://workdayz.in",
      "telephone": "",
      "email": "",
      "address": {
        "@type": "PostalAddress",
        "addressCountry": "IN",
        "addressRegion": "Rajasthan"
      },
      "geo": {
        "@type": "GeoCoordinates",
        "latitude": "26.2389",
        "longitude": "73.0243"
      },
      "hasMap": "https://maps.google.com/?q=Workdayz+by+Saraogi",
      "openingHoursSpecification": [
        {
          "@type": "OpeningHoursSpecification",
          "dayOfWeek": [
            "Monday",
            "Tuesday",
            "Wednesday",
            "Thursday",
            "Friday",
            "Saturday"
          ],
          "opens": "09:00",
          "closes": "18:00"
        }
      ],
      "priceRange": "₹₹",
      "currenciesAccepted": "INR",
      "paymentAccepted": "Cash, Bank Transfer, UPI, Credit Card",
      "areaServed": {
        "@type": "Country",
        "name": "India"
      },
      "logo": "https://workdayz.in/logo.png",
      "image": "https://workdayz.in/images/retail-brand-spaces-uniforms.jpg",
      "sameAs": [
        "https://in.linkedin.com/in/workdayz-uniforms-a2b72756"
      ],
      "serviceArea": {
        "@type": "Country",
        "name": "India"
      },
      "makesOffer": [
        {
          "@type": "Offer",
          "itemOffered": {
            "@type": "Service",
            "name": "Retail Brand Space Uniforms",
            "description": "Custom-designed uniforms for retail store staff that reinforce brand identity and elevate the in-store customer experience."
          }
        },
        {
          "@type": "Offer",
          "itemOffered": {
            "@type": "Service",
            "name": "Corporate Uniforms",
            "description": "Professional corporate workwear tailored for office and field staff."
          }
        },
        {
          "@type": "Offer",
          "itemOffered": {
            "@type": "Service",
            "name": "Hospitality Uniforms",
            "description": "Front desk, culinary, housekeeping, and spa uniforms for hotels and restaurants."
          }
        },
        {
          "@type": "Offer",
          "itemOffered": {
            "@type": "Service",
            "name": "Aviation Uniforms",
            "description": "Expertly fitted crew uniforms available in a wide variety of colours, cuts, and wear options."
          }
        },
        {
          "@type": "Offer",
          "itemOffered": {
            "@type": "Service",
            "name": "Healthcare Uniforms",
            "description": "Scrub suits, lab coats, nursing gowns, and patient dresses for medical facilities."
          }
        }
      ]
    },
    {
      "@context": "https://schema.org",
      "@type": "Service",
      "@id": "https://workdayz.in/uniform-manufacturer/retail-brand-spaces/#service",
      "name": "Retail Brand Space Uniform Manufacturing",
      "alternateName": "Retail Staff Uniform Design & Supply",
      "serviceType": "Custom Uniform Manufacturing",
      "description": "Workdayz by Saraogi designs and manufactures premium custom uniforms for retail brand spaces across India. Our retail uniforms are crafted to reflect brand identity, ensuring staff present a consistent, professional, and on-brand appearance across all store locations. Services include design consultation, fabric selection, logo embroidery, screen printing, and bulk manufacturing.",
      "url": "https://workdayz.in/uniform-manufacturer/retail-brand-spaces",
      "provider": {
        "@type": "Organization",
        "@id": "https://workdayz.in/#organization",
        "name": "Workdayz by Saraogi"
      },
      "areaServed": {
        "@type": "Country",
        "name": "India"
      },
      "hasOfferCatalog": {
        "@type": "OfferCatalog",
        "name": "Retail Brand Space Uniform Solutions",
        "itemListElement": [
          {
            "@type": "Offer",
            "itemOffered": {
              "@type": "Service",
              "name": "Custom Retail Staff Uniform Design"
            }
          },
          {
            "@type": "Offer",
            "itemOffered": {
              "@type": "Service",
              "name": "Logo Embroidery & Branding on Uniforms"
            }
          },
          {
            "@type": "Offer",
            "itemOffered": {
              "@type": "Service",
              "name": "Bulk Uniform Manufacturing for Retail Chains"
            }
          },
          {
            "@type": "Offer",
            "itemOffered": {
              "@type": "Service",
              "name": "Premium Fabric Sourcing for Retail Uniforms"
            }
          },
          {
            "@type": "Offer",
            "itemOffered": {
              "@type": "Service",
              "name": "Pan-India Uniform Supply & Delivery"
            }
          }
        ]
      },
      "category": "Uniform Manufacturing",
      "audience": {
        "@type": "BusinessAudience",
        "audienceType": "Retail Businesses, Brand Managers, Store Owners, Visual Merchandisers"
      },
      "termsOfService": "https://workdayz.in/terms",
      "image": "https://workdayz.in/images/retail-brand-spaces-uniforms.jpg"
    }
  ],
  "/uniform-manufacturer/government-police-defense": [
    {
      "@context": "https://schema.org",
      "@type": "LocalBusiness",
      "@id": "https://workdayz.in/#localbusiness",
      "name": "Workdayz — Government, Police & Defense Uniform Manufacturer",
      "alternateName": "Workdayz by Saraogi",
      "url": "https://workdayz.in/uniform-manufacturer/government-police-defense",
      "image": "https://workdayz.in/images/government-defense-uniforms.jpg",
      "description": "Workdayz is a premier manufacturer of government, police, and defense uniforms in Chennai, India. We supply Indian military uniform solutions, army dress uniforms, camouflage uniforms, ceremonial uniform apparel, police patrol uniforms, and tactical wear for government bodies and institutional procurement divisions across India.",
      "priceRange": "₹₹",
      "currenciesAccepted": "INR",
      "paymentAccepted": "Cash, Bank Transfer, Cheque, Online Payment",
      "address": {
        "@type": "PostalAddress",
        "streetAddress": "1/72, First Floor, Poonamallee High Road, Nerkundram",
        "addressLocality": "Chennai",
        "addressRegion": "Tamil Nadu",
        "postalCode": "600107",
        "addressCountry": "IN"
      },
      "geo": {
        "@type": "GeoCoordinates",
        "latitude": "13.0609",
        "longitude": "80.1534"
      },
      "telephone": "",
      "email": "st@workdayz.in",
      "openingHoursSpecification": [
        {
          "@type": "OpeningHoursSpecification",
          "dayOfWeek": [
            "Monday",
            "Tuesday",
            "Wednesday",
            "Thursday",
            "Friday",
            "Saturday"
          ],
          "opens": "09:00",
          "closes": "18:00"
        }
      ],
      "areaServed": [
        {
          "@type": "Country",
          "name": "India"
        },
        {
          "@type": "State",
          "name": "Tamil Nadu"
        }
      ],
      "hasMap": "https://maps.google.com/?q=1/72,+Poonamallee+High+Road,+Nerkundram,+Chennai+600107",
      "servesCuisine": null,
      "keywords": "government uniform manufacturer, military uniform manufacturer Chennai, indian army dress uniform, defense uniform supplier, police uniform manufacturer India, ceremonial uniform apparel, army camouflage uniform, bulk uniform manufacturer Chennai",
      "parentOrganization": {
        "@type": "Organization",
        "@id": "https://workdayz.in/#organization"
      }
    },
    {
      "@context": "https://schema.org",
      "@type": "Service",
      "@id": "https://workdayz.in/uniform-manufacturer/government-police-defense#service",
      "name": "Government, Police & Defense Uniform Manufacturing by Workdayz",
      "alternateName": "Indian Military Uniform Manufacturing",
      "description": "Workdayz provides end-to-end manufacturing of government, police, and defense uniforms for institutional procurement across India. Our offerings include Indian military uniforms, army dress uniforms, Indian army camouflage uniforms, ceremonial uniform apparel, police patrol uniforms, officer uniforms, administrative duty uniforms, and tactical wear. We support bulk orders with customization, quality inspection, and timely delivery.",
      "url": "https://workdayz.in/uniform-manufacturer/government-police-defense",
      "serviceType": "Uniform Manufacturing",
      "category": "Government & Defense Apparel Manufacturing",
      "availableChannel": {
        "@type": "ServiceChannel",
        "serviceUrl": "https://workdayz.in/uniform-manufacturer/government-police-defense",
        "availableLanguage": ["English", "Hindi", "Tamil"]
      },
      "provider": {
        "@type": "Organization",
        "@id": "https://workdayz.in/#organization",
        "name": "Workdayz by Saraogi",
        "contactPoint": {
          "@type": "ContactPoint",
          "email": "st@workdayz.in",
          "contactType": "customer support",
          "availableLanguage": ["English", "Hindi", "Tamil"]
        }
      },
      "areaServed": {
        "@type": "Country",
        "name": "India"
      },
      "audience": {
        "@type": "Audience",
        "audienceType": "Government Organizations, Defense Departments, Police Departments, Law Enforcement Agencies, Institutional Procurement Divisions"
      },
      "hasOfferCatalog": {
        "@type": "OfferCatalog",
        "name": "Government & Defense Uniform Product Range",
        "itemListElement": [
          {
            "@type": "Offer",
            "itemOffered": {
              "@type": "Product",
              "name": "Indian Army Dress Uniform",
              "description": "Precision-tailored army dress uniforms for institutional supply and government procurement.",
              "brand": {
                "@type": "Brand",
                "name": "Workdayz"
              }
            }
          },
          {
            "@type": "Offer",
            "itemOffered": {
              "@type": "Product",
              "name": "Indian Army Camouflage Uniform",
              "description": "Durable and breathable camouflage uniforms designed for field and tactical use."
            }
          },
          {
            "@type": "Offer",
            "itemOffered": {
              "@type": "Product",
              "name": "Ceremonial Uniform Apparel",
              "description": "High-quality ceremonial dress uniforms for parades, official events, and public ceremonies."
            }
          },
          {
            "@type": "Offer",
            "itemOffered": {
              "@type": "Product",
              "name": "Police Patrol Uniform",
              "description": "Functional and durable patrol uniforms for law enforcement and police departments."
            }
          },
          {
            "@type": "Offer",
            "itemOffered": {
              "@type": "Product",
              "name": "Officer Uniform",
              "description": "Structured and professional officer uniforms for defense and government administrative roles."
            }
          },
          {
            "@type": "Offer",
            "itemOffered": {
              "@type": "Product",
              "name": "Tactical Wear",
              "description": "Durable tactical uniforms designed for operational and field use in defense and security sectors."
            }
          },
          {
            "@type": "Offer",
            "itemOffered": {
              "@type": "Product",
              "name": "Administrative Duty Uniform",
              "description": "Professional administrative uniforms for government and defense office roles."
            }
          },
          {
            "@type": "Offer",
            "itemOffered": {
              "@type": "Product",
              "name": "Uniform Accessories",
              "description": "Belts, caps, badges, insignia, and embroidery elements supplied along with uniform orders."
            }
          }
        ]
      },
      "offers": {
        "@type": "Offer",
        "name": "Bulk Government & Defense Uniform Order",
        "description": "Customized bulk manufacturing of government, police, and defense uniforms for institutional procurement across India.",
        "url": "https://workdayz.in/uniform-manufacturer/government-police-defense",
        "priceCurrency": "INR",
        "availability": "https://schema.org/InStock",
        "seller": {
          "@type": "Organization",
          "@id": "https://workdayz.in/#organization"
        }
      }
    }
  ],
  "/uniform-manufacturer/pilot-uniforms-aviation": [
    {
      "@context": "https://schema.org",
      "@type": "LocalBusiness",
      "name": "Workdayz",
      "alternateName": "Saraogi Clothing Company",
      "description": "Leading manufacturer and supplier of pilot uniforms, airline pilot uniforms, flight attendant uniforms, and aviation workwear across India.",
      "url": "https://workdayz.in",
      "telephone": "+91-7358376222",
      "email": "contact@saraogi.in",
      "address": {
        "@type": "PostalAddress",
        "streetAddress": "First Floor, 1/72, Poonamallee High Rd, Nerkundram",
        "addressLocality": "Chennai",
        "addressRegion": "Tamil Nadu",
        "postalCode": "600107",
        "addressCountry": "IN"
      },
      "areaServed": "India",
      "knowsAbout": [
        "Pilot Uniforms",
        "Airline Pilot Uniforms",
        "Flight Attendant Uniforms",
        "Aviation Workwear",
        "Student Pilot Uniforms",
        "Ground Staff Uniforms"
      ],
      "hasOfferCatalog": {
        "@type": "OfferCatalog",
        "name": "Aviation Uniform Range",
        "itemListElement": [
          {
            "@type": "Offer",
            "itemOffered": {
              "@type": "Product",
              "name": "Airline Pilot Uniform",
              "description": "Four-stripe captain and co-pilot uniforms with rank epaulettes and wing badges",
              "category": "Pilot Uniform",
              "image": "https://workdayz.in/images/airline-pilot-uniform.jpg",
              "brand": {
                "@type": "Brand",
                "name": "Workdayz"
              },
              "offers": {
                "@type": "Offer",
                "priceCurrency": "INR",
                "price": "499",
                "priceValidUntil": "2026-12-31",
                "availability": "https://schema.org/InStock",
                "url": "https://workdayz.in",
                "seller": {
                  "@type": "Organization",
                  "name": "Workdayz"
                }
              }
            }
          },
          {
            "@type": "Offer",
            "itemOffered": {
              "@type": "Product",
              "name": "Flight Attendant Uniform",
              "description": "Cabin crew uniform sets including saree, trouser suit, and skirt-blouse combinations",
              "category": "Flight Attendant Uniform",
              "image": "https://workdayz.in/images/flight-attendant-uniform.jpg",
              "brand": {
                "@type": "Brand",
                "name": "Workdayz"
              },
              "offers": {
                "@type": "Offer",
                "priceCurrency": "INR",
                "price": "499",
                "priceValidUntil": "2026-12-31",
                "availability": "https://schema.org/InStock",
                "url": "https://workdayz.in",
                "seller": {
                  "@type": "Organization",
                  "name": "Workdayz"
                }
              }
            }
          },
          {
            "@type": "Offer",
            "itemOffered": {
              "@type": "Product",
              "name": "Student Pilot Uniform",
              "description": "Cadet pilot uniforms for aviation academies and flight training organisations",
              "category": "Student Pilot Uniform",
              "image": "https://workdayz.in/images/student-pilot-uniform.jpg",
              "brand": {
                "@type": "Brand",
                "name": "Workdayz"
              },
              "offers": {
                "@type": "Offer",
                "priceCurrency": "INR",
                "price": "499",
                "priceValidUntil": "2026-12-31",
                "availability": "https://schema.org/InStock",
                "url": "https://workdayz.in",
                "seller": {
                  "@type": "Organization",
                  "name": "Workdayz"
                }
              }
            }
          },
          {
            "@type": "Offer",
            "itemOffered": {
              "@type": "Product",
              "name": "Ground Staff Uniform",
              "description": "Airport ground operations and check-in counter staff uniforms",
              "category": "Aviation Ground Staff Uniform",
              "image": "https://workdayz.in/images/ground-staff-uniform.jpg",
              "brand": {
                "@type": "Brand",
                "name": "Workdayz"
              },
              "offers": {
                "@type": "Offer",
                "priceCurrency": "INR",
                "price": "499",
                "priceValidUntil": "2026-12-31",
                "availability": "https://schema.org/InStock",
                "url": "https://workdayz.in",
                "seller": {
                  "@type": "Organization",
                  "name": "Workdayz"
                }
              }
            }
          }
        ]
      }
    }
  ],
  "/uniform-manufacturer/healthcare-clinics-wellness": [
    {
      "@context": "https://schema.org",
      "@type": "LocalBusiness",
      "name": "Workdayz",
      "description": "Leading manufacturer and supplier of hospital uniforms, hospital staff dress, and medical uniforms across India.",
      "url": "https://workdayz.in",
      "telephone": "+91-XXXXXXXXXX",
      "address": {
        "@type": "PostalAddress",
        "addressCountry": "IN"
      },
      "areaServed": "India",
      "knowsAbout": [
        "Hospital Uniforms",
        "Medical Staff Uniforms",
        "Hospital Uniform Manufacturing",
        "Healthcare Apparel"
      ],
      "hasOfferCatalog": {
        "@type": "OfferCatalog",
        "name": "Hospital Uniform Range",
        "itemListElement": [
          {
            "@type": "Offer",
            "itemOffered": {
              "@type": "Product",
              "name": "Doctor Hospital Uniform",
              "description": "Lightweight breathable hospital uniforms for doctors and consultants",
              "category": "Hospital Uniform",
              "image": "https://workdayz.in/images/doctor-uniform.jpg",
              "brand": {
                "@type": "Brand",
                "name": "Workdayz"
              },
              "offers": {
                "@type": "Offer",
                "priceCurrency": "INR",
                "price": "499",
                "priceValidUntil": "2026-12-31",
                "availability": "https://schema.org/InStock",
                "url": "https://workdayz.in",
                "seller": {
                  "@type": "Organization",
                  "name": "Workdayz"
                }
              }
            }
          },
          {
            "@type": "Offer",
            "itemOffered": {
              "@type": "Product",
              "name": "Nurse Hospital Uniform",
              "description": "Antimicrobial scrub sets for nursing staff",
              "category": "Hospital Staff Dress",
              "image": "https://workdayz.in/images/nurse-uniform.jpg",
              "brand": {
                "@type": "Brand",
                "name": "Workdayz"
              },
              "offers": {
                "@type": "Offer",
                "priceCurrency": "INR",
                "price": "399",
                "priceValidUntil": "2026-12-31",
                "availability": "https://schema.org/InStock",
                "url": "https://workdayz.in",
                "seller": {
                  "@type": "Organization",
                  "name": "Workdayz"
                }
              }
            }
          },
          {
            "@type": "Offer",
            "itemOffered": {
              "@type": "Product",
              "name": "OT Scrubs",
              "description": "Lint-free operation theatre uniforms for surgical staff",
              "category": "Medical Staff Uniforms",
              "image": "https://workdayz.in/images/ot-scrubs.jpg",
              "brand": {
                "@type": "Brand",
                "name": "Workdayz"
              },
              "offers": {
                "@type": "Offer",
                "priceCurrency": "INR",
                "price": "449",
                "priceValidUntil": "2026-12-31",
                "availability": "https://schema.org/InStock",
                "url": "https://workdayz.in",
                "seller": {
                  "@type": "Organization",
                  "name": "Workdayz"
                }
              }
            }
          }
        ]
      }
    }
  ],
  "/uniform-manufacturer/educational-institutions": [
    {
      "@context": "https://schema.org",
      "@type": "LocalBusiness",
      "@id": "https://workdayz.in/#organization",
      "name": "Workdayz – The Saraogi Clothing Company",
      "url": "https://workdayz.in",
      "logo": "https://workdayz.in/logo.png",
      "image": "https://workdayz.in/images/workdayz-school-uniform-manufacturers-india.jpg",
      "description": "Workdayz is a leading school uniform manufacturer and supplier in India, designing durable, comfortable uniforms for students, educators, and staff across all institution types.",
      "telephone": "+91-7358376222",
      "email": "contact@saraogi.in",
      "address": {
        "@type": "PostalAddress",
        "streetAddress": "First Floor, 1/72, Poonamallee High Road, Nerkundram",
        "addressLocality": "Chennai",
        "addressRegion": "Tamil Nadu",
        "postalCode": "600107",
        "addressCountry": "IN"
      },
      "geo": {
        "@type": "GeoCoordinates",
        "latitude": "[INSERT LATITUDE]",
        "longitude": "[INSERT LONGITUDE]"
      },
      "areaServed": {
        "@type": "Country",
        "name": "India"
      },
      "sameAs": [
        "https://wa.me/917358376222"
      ],
      "openingHoursSpecification": {
        "@type": "OpeningHoursSpecification",
        "dayOfWeek": [
          "Monday",
          "Tuesday",
          "Wednesday",
          "Thursday",
          "Friday",
          "Saturday"
        ],
        "opens": "09:00",
        "closes": "18:00"
      }
    },
    {
      "@context": "https://schema.org",
      "@type": "Product",
      "name": "School Uniform",
      "description": "Premium school uniforms manufactured by Workdayz for primary, middle, high school, and college students across India. Durable, comfortable, and fully customisable with school logos and colours.",
      "brand": {
        "@type": "Brand",
        "name": "Workdayz"
      },
      "manufacturer": {
        "@type": "Organization",
        "name": "Workdayz – The Saraogi Clothing Company",
        "url": "https://workdayz.in"
      },
      "category": "School Uniforms",
      "offers": {
        "@type": "AggregateOffer",
        "url": "https://workdayz.in/uniform-manufacturer/educational-institutions",
        "priceCurrency": "INR",
        "lowPrice": "150",
        "highPrice": "2500",
        "offerCount": "8",
        "availability": "https://schema.org/InStock",
        "itemCondition": "https://schema.org/NewCondition",
        "seller": {
          "@type": "Organization",
          "name": "Workdayz"
        }
      },
      "additionalProperty": [
        {
          "@type": "PropertyValue",
          "name": "Customization",
          "value": "School logo, colours, embroidery"
        },
        {
          "@type": "PropertyValue",
          "name": "Target Group",
          "value": "KG, Primary, Middle, High School, College, Staff"
        },
        {
          "@type": "PropertyValue",
          "name": "Order Type",
          "value": "Bulk Orders Available"
        }
      ]
    },
    {
      "@context": "https://schema.org",
      "@type": "Service",
      "name": "School Uniform Manufacturing & Supply",
      "url": "https://workdayz.in/uniform-manufacturer/educational-institutions",
      "description": "End-to-end school uniform manufacturing and supply service for educational institutions across India. Includes design, sampling, bulk production, logo embroidery, packaging, and delivery.",
      "provider": {
        "@type": "Organization",
        "name": "Workdayz – The Saraogi Clothing Company",
        "url": "https://workdayz.in",
        "@id": "https://workdayz.in/#organization"
      },
      "serviceType": "Uniform Manufacturing",
      "areaServed": "India",
      "availableChannel": {
        "@type": "ServiceChannel",
        "serviceUrl": "https://workdayz.in/uniform-manufacturer/educational-institutions",
        "servicePhone": "+91-7358376222"
      },
      "hasOfferCatalog": {
        "@type": "OfferCatalog",
        "name": "Educational Uniform Range",
        "itemListElement": [
          {
            "@type": "Offer",
            "itemOffered": {
              "@type": "Service",
              "name": "Primary School Uniforms"
            }
          },
          {
            "@type": "Offer",
            "itemOffered": {
              "@type": "Service",
              "name": "Middle School Uniforms"
            }
          },
          {
            "@type": "Offer",
            "itemOffered": {
              "@type": "Service",
              "name": "High School Uniforms"
            }
          },
          {
            "@type": "Offer",
            "itemOffered": {
              "@type": "Service",
              "name": "Kindergarten (KG) Uniforms"
            }
          },
          {
            "@type": "Offer",
            "itemOffered": {
              "@type": "Service",
              "name": "Higher Education / College Uniforms"
            }
          },
          {
            "@type": "Offer",
            "itemOffered": {
              "@type": "Service",
              "name": "Sports / PT Dress Uniforms"
            }
          },
          {
            "@type": "Offer",
            "itemOffered": {
              "@type": "Service",
              "name": "Rainwear Uniforms"
            }
          },
          {
            "@type": "Offer",
            "itemOffered": {
              "@type": "Service",
              "name": "Staff Uniforms"
            }
          }
        ]
      }
    }
  ],
  "/uniform-manufacturer/industrial": [
    {
      "@context": "https://schema.org",
      "@type": ["LocalBusiness"],
      "@id": "https://workdayz.in/#localbusiness",
      "name": "Workdayz by Saraogi – Hospitality Uniform Manufacturer",
      "legalName": "Saraogi Clothing LLP",
      "image": "https://workdayz.in/logo.png",
      "url": "https://workdayz.in/uniform-manufacturer/hospitality-resorts",
      "telephone": "+91-44-0000-0000",
      "email": "st@workdayz.in",
      "priceRange": "₹₹",
      "currenciesAccepted": "INR",
      "paymentAccepted": "Bank Transfer, Cheque, UPI, NEFT",
      "description": "Workdayz by Saraogi is a leading hospitality uniform manufacturer in Chennai, India. We supply custom-designed hotel, resort, restaurant, and spa uniforms to properties across India and Asia, combining premium fabrics with brand-specific embroidery and printing.",
      "address": {
        "@type": "PostalAddress",
        "streetAddress": "1/72, Poonamallee High Road, Nerkundram",
        "addressLocality": "Chennai",
        "addressRegion": "Tamil Nadu",
        "postalCode": "600107",
        "addressCountry": "IN"
      },
      "geo": {
        "@type": "GeoCoordinates",
        "latitude": 13.0584,
        "longitude": 80.1777
      },
      "openingHoursSpecification": [
        {
          "@type": "OpeningHoursSpecification",
          "dayOfWeek": ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday"],
          "opens": "09:30",
          "closes": "18:30"
        },
        {
          "@type": "OpeningHoursSpecification",
          "dayOfWeek": "Saturday",
          "opens": "09:30",
          "closes": "14:00"
        }
      ],
      "hasMap": "https://www.google.com/maps/search/Workdayz+Saraogi+Chennai",
      "sameAs": [
        "https://workdayz.in",
        "https://www.indiamart.com/saraogiclothing-in-2513481/",
        "https://saraogiuniforms.com"
      ],
      "knowsAbout": [
        "Hospitality Uniforms",
        "Hotel Staff Uniforms",
        "Resort Uniforms",
        "Chef Uniforms",
        "Custom Workwear",
        "Embroidered Logo Uniforms",
        "F&B Staff Uniforms",
        "Housekeeping Uniforms"
      ],
      "makesOffer": [
        {
          "@type": "Offer",
          "itemOffered": {
            "@type": "Service",
            "name": "Custom Hospitality Uniform Manufacturing",
            "description": "Design, manufacture, and delivery of branded hospitality uniforms for hotels, resorts, and restaurants."
          }
        }
      ],
      "areaServed": {
        "@type": "Country",
        "name": "India"
      },
      "founder": {
        "@type": "Person",
        "name": "Anil Kumar Jain"
      },
      "foundingDate": "2006"
    },
    {
      "@context": "https://schema.org",
      "@type": "Service",
      "@id": "https://workdayz.in/uniform-manufacturer/hospitality-resorts#service",
      "name": "Hospitality & Resort Uniform Manufacturing",
      "alternateName": "Hotel Uniform Manufacturer India",
      "description": "Workdayz by Saraogi offers end-to-end custom uniform manufacturing for hotels, resorts, and hospitality businesses across India and Asia. Services include design consultation, fabric selection, logo embroidery and printing, bulk manufacturing, quality control, and pan-India delivery.",
      "serviceType": "Uniform Manufacturing & Customisation",
      "category": "Hospitality Workwear",
      "url": "https://workdayz.in/uniform-manufacturer/hospitality-resorts",
      "mainEntityOfPage": {
        "@type": "WebPage",
        "@id": "https://workdayz.in/uniform-manufacturer/hospitality-resorts"
      },
      "provider": {
        "@type": "Organization",
        "@id": "https://workdayz.in/#organization",
        "name": "Workdayz by Saraogi",
        "url": "https://workdayz.in"
      },
      "areaServed": [
        {
          "@type": "Country",
          "name": "India"
        },
        {
          "@type": "AdministrativeArea",
          "name": "Asia"
        }
      ],
      "audience": {
        "@type": "Audience",
        "audienceType": "Hotels, Resorts, Restaurants, Spa & Wellness Centres, Banquet Facilities, Hospitality Businesses"
      },
      "offers": {
        "@type": "Offer",
        "name": "Custom Hospitality Uniform Manufacturing",
        "description": "Bulk custom uniform manufacturing for hospitality businesses including hotels, resorts, restaurants, and spas across India.",
        "priceCurrency": "INR",
        "availability": "https://schema.org/InStock",
        "itemOffered": {
          "@type": "Service",
          "@id": "https://workdayz.in/uniform-manufacturer/hospitality-resorts#service"
        },
        "seller": {
          "@type": "Organization",
          "name": "Workdayz by Saraogi",
          "url": "https://workdayz.in"
        }
      },
      "hasOfferCatalog": {
        "@type": "OfferCatalog",
        "name": "Hospitality Uniform Range",
        "itemListElement": [
          {
            "@type": "Offer",
            "position": 1,
            "itemOffered": {
              "@type": "Service",
              "name": "Front Desk & Concierge Uniforms",
              "description": "Formal, brand-aligned uniforms for reception, concierge, and guest relations staff."
            }
          },
          {
            "@type": "Offer",
            "position": 2,
            "itemOffered": {
              "@type": "Service",
              "name": "Housekeeping Uniforms",
              "description": "Durable, easy-care uniforms designed for housekeeping and laundry staff."
            }
          },
          {
            "@type": "Offer",
            "position": 3,
            "itemOffered": {
              "@type": "Service",
              "name": "F&B Staff Uniforms",
              "description": "Stylish uniforms for restaurant, bar, and room-service staff."
            }
          },
          {
            "@type": "Offer",
            "position": 4,
            "itemOffered": {
              "@type": "Service",
              "name": "Chef Coats & Kitchen Wear",
              "description": "Heat-resistant, hygienic chef coats, aprons, and kitchen uniforms."
            }
          },
          {
            "@type": "Offer",
            "position": 5,
            "itemOffered": {
              "@type": "Service",
              "name": "Bell Boy & Valet Uniforms",
              "description": "Smart, tailored uniforms for bell desk, valet, and porter staff."
            }
          },
          {
            "@type": "Offer",
            "position": 6,
            "itemOffered": {
              "@type": "Service",
              "name": "Spa & Wellness Staff Uniforms",
              "description": "Soft, comfortable, and professional uniforms for spa therapists and wellness teams."
            }
          }
        ]
      },
      "serviceOutput": {
        "@type": "Service",
        "name": "Custom Hospitality Uniforms with Logo Branding",
        "description": "Finished bulk uniform sets with custom logo embroidery or printing, tailored to hospitality brand identity."
      },
      "potentialAction": {
        "@type": "OrderAction",
        "target": {
          "@type": "EntryPoint",
          "urlTemplate": "https://workdayz.in/contact",
          "actionPlatform": "https://schema.org/DesktopWebPlatform"
        }
      }
    }
  ],
  "/uniform-manufacturer/:slug": [],
  "/design-studio": [],
  "/project": [],
  "/ambience-and-harmony": [],
  "/contact": [],
  "/blog/:slug": [],
  "/courses/:id": [],
  "/thank-you": [],
  "/success": [],
  "/privacy-policy": [],
  "/one-on-one-transformation": [],
};

// Hospitality page currently uses the supplied LocalBusiness and Service schemas.
// Deep cloning keeps this route's schema objects separate from the industrial route.
pageSchemas["/uniform-manufacturer/hospitality-resorts"] = pageSchemas[
  "/uniform-manufacturer/industrial"
].map((schema) => JSON.parse(JSON.stringify(schema)));

export default pageSchemas;
